import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Solutions from './pages/Solutions';
import AutomationSolution from './pages/solutions/AutomationSolution';
import ArtificialIntelligence from './pages/solutions/ArtificialIntelligence';
import DataEngineeringSolution from './pages/solutions/DataEngineeringSolution';
import WebMobileDevelopment from './pages/solutions/WebMobileDevelopment';
import BIAnalyticsSolution from './pages/solutions/BIAnalyticsSolution';
import CloudMigrationSolution from './pages/solutions/CloudMigrationSolution';
import AIAuditSolution from './pages/solutions/AIAuditSolution';
import Contact from './pages/Contact';
import Insights from './pages/Insights';
import Careers from './pages/Careers';
import CaseStudies from './pages/CaseStudies';
import Industries from './pages/Industries';
import RetailAnalytics from './pages/case-studies/RetailAnalytics';
import HealthcareAI from './pages/case-studies/HealthcareAI';
import HealthcareCommunication from './pages/case-studies/HealthcareCommunication';
import InsuranceAutomation from './pages/case-studies/InsuranceAutomation';
import ManufacturingAI from './pages/case-studies/ManufacturingAI';
import PaymentAutomation from './pages/case-studies/PaymentAutomation';
import PharmaAnalytics from './pages/case-studies/PharmaAnalytics';
import CloudPlatformMigration from './pages/case-studies/CloudPlatformMigration';
import SportsPrediction from './pages/case-studies/SportsPrediction';
import HSNClassification from './pages/case-studies/HSNClassification';
import FMCGMigration from './pages/case-studies/FMCGMigration';
import MarketingAutomation from './pages/case-studies/MarketingAutomation';
import HealthcareAudit from './pages/case-studies/HealthcareAudit';
import ShipChandlerRFQ from './pages/case-studies/ShipChandlerRFQ';
import TradingAutomation from './pages/case-studies/TradingAutomation';
import CrosbyProposal from './pages/proposals/CrosbyProposal';
import RecursiveLanguageModels from './pages/blogs/RecursiveLanguageModels';
import Blog19052026 from './pages/blogs/Blog19052026';
import Blog17052026 from './pages/blogs/Blog17052026';
import Blog16052026 from './pages/blogs/Blog16052026';
import Blog15052026 from './pages/blogs/Blog15052026';
import Blog14052026 from './pages/blogs/Blog14052026';
import Blog12052026 from './pages/blogs/Blog12052026';
import Blog09052026 from './pages/blogs/Blog09052026';
import Blog08052026 from './pages/blogs/Blog08052026';
import Blog07052026 from './pages/blogs/Blog07052026';
import Blog06052026 from './pages/blogs/Blog06052026';
import Blog05052026 from './pages/blogs/Blog05052026';
import Blog03052026 from './pages/blogs/Blog03052026';
import Blog30042026 from './pages/blogs/Blog30042026';
import Blog28042026 from './pages/blogs/Blog28042026';
import Blog27042026 from './pages/blogs/Blog27042026';
import Blog25042026 from './pages/blogs/Blog25042026';
import Blog22042026 from './pages/blogs/Blog22042026';
import Blog21042026 from './pages/blogs/Blog21042026';
import Blog20042026 from './pages/blogs/Blog20042026';
import Blog17042026 from './pages/blogs/Blog17042026';
import Blog16042026 from './pages/blogs/Blog16042026';
import Blog14042026 from './pages/blogs/Blog14042026';
import Blog13042026 from './pages/blogs/Blog13042026';
import Blog12042026 from './pages/blogs/Blog12042026';
import Blog11042026 from './pages/blogs/Blog11042026';
import Blog09042026 from './pages/blogs/Blog09042026';
import Blog07042026 from './pages/blogs/Blog07042026';
import Blog06042026 from './pages/blogs/Blog06042026';
import Blog02042026 from './pages/blogs/Blog02042026';
import Blog01042026 from './pages/blogs/Blog01042026';
import Blog28032026 from './pages/blogs/Blog28032026';
import Blog26032026 from './pages/blogs/Blog26032026';
import Blog25032026 from './pages/blogs/Blog25032026';
import Blog23032026 from './pages/blogs/Blog23032026';
import Blog19032026 from './pages/blogs/Blog19032026';
import Blog18032026 from './pages/blogs/Blog18032026';
import Blog17032026 from './pages/blogs/Blog17032026';
import Blog15032026 from './pages/blogs/Blog15032026';
import Blog13032026 from './pages/blogs/Blog13032026';
import Blog12032026 from './pages/blogs/Blog12032026';
import Blog11032026 from './pages/blogs/Blog11032026';
import Blog10032026 from './pages/blogs/Blog10032026';
import Blog09032026 from './pages/blogs/Blog09032026';
import Blog08032026 from './pages/blogs/Blog08032026';
import Blog06032026 from './pages/blogs/Blog06032026';
import Blog05032026 from './pages/blogs/Blog05032026';
import Blog04032026 from './pages/blogs/Blog04032026';
import Blog01032026 from './pages/blogs/Blog01032026';
import Blog26022026 from './pages/blogs/Blog26022026';
import Blog22022026 from './pages/blogs/Blog22022026';
import Blog21022026 from './pages/blogs/Blog21022026';
import Blog20022026 from './pages/blogs/Blog20022026';
import Blog19022026 from './pages/blogs/Blog19022026';
import Blog18022026 from './pages/blogs/Blog18022026';
import Blog17022026 from './pages/blogs/Blog17022026';
import Blog16022026 from './pages/blogs/Blog16022026';
import Blog15022026 from './pages/blogs/Blog15022026';
import Blog14022026 from './pages/blogs/Blog14022026';
import Blog13022026 from './pages/blogs/Blog13022026';
import Blog12022026 from './pages/blogs/Blog12022026';
import Blog11022026 from './pages/blogs/Blog11022026';
import Blog10022026 from './pages/blogs/Blog10022026';
import Blog09022026 from './pages/blogs/Blog09022026';
import Blog08022026 from './pages/blogs/Blog08022026';
import Blog07022026 from './pages/blogs/Blog07022026';
import Blog06022026 from './pages/blogs/Blog06022026';
import Blog05022026 from './pages/blogs/Blog05022026';
import Blog04022026 from './pages/blogs/Blog04022026';
import Blog03022026 from './pages/blogs/Blog03022026';
import Blog02022026 from './pages/blogs/Blog02022026';
import Blog01022026 from './pages/blogs/Blog01022026';
import Blog31012026 from './pages/blogs/Blog31012026';
import Blog30012026 from './pages/blogs/Blog30012026';
import Blog29012026 from './pages/blogs/Blog29012026';
import Blog28012026 from './pages/blogs/Blog28012026';
import Blog27012026Posted from './pages/blogs/Blog27012026Posted';
import Reg20012026Posted from './pages/blogs/Reg20012026Posted';
import SmartVideoPreviews22012026Posted from './pages/blogs/SmartVideoPreviews22012026Posted';
import Blog24012026Posted from './pages/blogs/Blog24012026Posted';
import AgentLightningDrives24012026Posted from './pages/blogs/AgentLightningDrives24012026Posted';
import AIAGENTS23012026Posted from './pages/blogs/AIAGENTS23012026Posted';
import AISEO21012026Posted from './pages/blogs/AISEO21012026Posted';
import AISEOMarketing from './pages/blogs/AISEOMarketing';
import SmartVideoPreviews from './pages/blogs/SmartVideoPreviews';
import AIAgents from './pages/blogs/AIAgents';
import AgentLightning from './pages/blogs/AgentLightning';
import SpeedImplementation from './pages/SpeedImplementation';
import YouTube from './pages/YouTube';
import AIImplementationServices from './pages/services/AIImplementationServices';
import HireAIDevelopers from './pages/services/HireAIDevelopers';
import AIConsultingUSA from './pages/locations/AIConsultingUSA';
import AIConsultingAhmedabad from './pages/locations/AIConsultingAhmedabad';
import AIConsultingIndia from './pages/locations/AIConsultingIndia';
import OpenAIGPTDevelopment from './pages/technologies/OpenAIGPTDevelopment';
import AIAnalyticsSolution from './pages/solutions/AIAnalyticsSolution';
import GenerativeAIConsulting from './pages/services/GenerativeAIConsulting';
import AIConsultingUK from './pages/services/AIConsultingUK';
import FMCGAI from './pages/services/FMCGAI';
import PharmaceuticalMarketingAnalytics from './pages/services/PharmaceuticalMarketingAnalytics';
import SportsAnalytics from './pages/services/SportsAnalytics';
import MaritimeAI from './pages/services/MaritimeAI';
import AIConsultingHealthcare from './pages/industries/AIConsultingHealthcare';
import AIConsultingInsurance from './pages/industries/AIConsultingInsurance';
import AIConsultingLogistics from './pages/industries/AIConsultingLogistics';
import FMCG from './pages/industries/FMCG';
import GlobalTrade from './pages/industries/GlobalTrade';
import TradingInvestment from './pages/industries/TradingInvestment';
import Maritime from './pages/industries/Maritime';
import SportsEntertainment from './pages/industries/SportsEntertainment';
import PharmaceuticalMarketing from './pages/industries/PharmaceuticalMarketing';
import ThinCityPage from './pages/locations/ThinCityPage';
import AIAssistant from './components/AIAssistant';

// Scroll restoration component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
};

// Routes wrapper with location key to force remount on navigation
const RoutesWithLocation = () => {
  const location = useLocation();

  return (
    <Routes key={location.pathname}>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/solutions" element={<Solutions />} />
      <Route path="/solutions/automation" element={<AutomationSolution />} />
      <Route path="/solutions/artificial-intelligence" element={<ArtificialIntelligence />} />
      <Route path="/solutions/data-engineering" element={<DataEngineeringSolution />} />
      <Route path="/solutions/web-mobile-development" element={<WebMobileDevelopment />} />
      <Route path="/solutions/bi-analytics" element={<BIAnalyticsSolution />} />
      <Route path="/solutions/cloud-migration" element={<CloudMigrationSolution />} />
      <Route path="/solutions/ai-audit" element={<AIAuditSolution />} />
      <Route path="/speed" element={<SpeedImplementation />} />
      <Route path="/ai-implementation-services" element={<AIImplementationServices />} />
      <Route path="/hire-ai-developers" element={<HireAIDevelopers />} />
      <Route path="/ai-consulting-company-usa" element={<AIConsultingUSA />} />
      <Route path="/ai-consulting-company-ahmedabad" element={<AIConsultingAhmedabad />} />
      <Route path="/ai-consulting-india" element={<AIConsultingIndia />} />
      <Route path="/openai-gpt-development" element={<OpenAIGPTDevelopment />} />
      <Route path="/solutions/ai-analytics" element={<AIAnalyticsSolution />} />
      <Route path="/generative-ai-consulting" element={<GenerativeAIConsulting />} />
      <Route path="/ai-consulting-uk" element={<AIConsultingUK />} />
      <Route path="/fmcg-ai" element={<FMCGAI />} />
      <Route path="/pharmaceutical-marketing-analytics" element={<PharmaceuticalMarketingAnalytics />} />
      <Route path="/sports-analytics" element={<SportsAnalytics />} />
      <Route path="/maritime-ai" element={<MaritimeAI />} />
      <Route path="/ai-consulting-healthcare" element={<AIConsultingHealthcare />} />
      <Route path="/ai-consulting-insurance" element={<AIConsultingInsurance />} />
      <Route path="/ai-consulting-logistics" element={<AIConsultingLogistics />} />
      {/* Thin city pages noindex, excluded from sitemap */}
      <Route path="/ai-consulting-new-york" element={<ThinCityPage city="New York" state="NY" />} />
      <Route path="/ai-consulting-chicago" element={<ThinCityPage city="Chicago" state="IL" />} />
      <Route path="/ai-consulting-san-francisco" element={<ThinCityPage city="San Francisco" state="CA" />} />
      <Route path="/industries" element={<Industries />} />
      <Route path="/industries/fmcg" element={<FMCG />} />
      <Route path="/industries/global-trade" element={<GlobalTrade />} />
      <Route path="/industries/trading-investment" element={<TradingInvestment />} />
      <Route path="/industries/maritime" element={<Maritime />} />
      <Route path="/industries/sports-entertainment" element={<SportsEntertainment />} />
      <Route path="/industries/pharmaceutical-marketing" element={<PharmaceuticalMarketing />} />
      <Route path="/case-studies" element={<CaseStudies />} />
      <Route path="/case-studies/retail-analytics" element={<RetailAnalytics />} />
      <Route path="/case-studies/healthcare-ai" element={<HealthcareAI />} />
      <Route path="/case-studies/healthcare-communication" element={<HealthcareCommunication />} />
      <Route path="/case-studies/insurance-automation" element={<InsuranceAutomation />} />
      <Route path="/case-studies/manufacturing-ai" element={<ManufacturingAI />} />
      <Route path="/case-studies/payment-automation" element={<PaymentAutomation />} />
      <Route path="/case-studies/pharma-analytics" element={<PharmaAnalytics />} />
      <Route path="/case-studies/cloud-platform-migration" element={<CloudPlatformMigration />} />
      <Route path="/case-studies/sports-prediction" element={<SportsPrediction />} />
      <Route path="/case-studies/hsn-classification" element={<HSNClassification />} />
      <Route path="/case-studies/fmcg-migration" element={<FMCGMigration />} />
      <Route path="/case-studies/marketing-automation" element={<MarketingAutomation />} />
      <Route path="/case-studies/healthcare-audit" element={<HealthcareAudit />} />
      <Route path="/case-studies/ship-chandler-rfq" element={<ShipChandlerRFQ />} />
      <Route path="/case-studies/trading-automation" element={<TradingAutomation />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/insights" element={<Insights />} />
            <Route path="/insights/master-the-stage-how-mits-40year" element={<Blog19052026 />} />
            <Route path="/insights/from-handloom-your-textile-business-ready" element={<Blog17052026 />} />
            <Route path="/insights/can-googles-aienabled-pointer-truly-revolutionize" element={<Blog16052026 />} />
            <Route path="/insights/are-startups-really-worth-half-the" element={<Blog15052026 />} />
            <Route path="/insights/your-claude-subscription-25x-more-powerful" element={<Blog14052026 />} />
            <Route path="/insights/your-research-falling-behind-how-opensource" element={<Blog12052026 />} />
            <Route path="/insights/are-your-coding-limits-holding-you" element={<Blog09052026 />} />
            <Route path="/insights/are-you-maximizing-your-productivity-how" element={<Blog08052026 />} />
            <Route path="/insights/your-manufacturing-plant-ready-boost-efficiency" element={<Blog07052026 />} />
            <Route path="/insights/your-project-safe-understanding-the-pytorch" element={<Blog06052026 />} />
            <Route path="/insights/can-google-really-transform-your-small" element={<Blog05052026 />} />
            <Route path="/insights/gpt55-pro-the-key-unlocking-your" element={<Blog03052026 />} />
            <Route path="/insights/are-claudes-latest-updates-the-secret" element={<Blog30042026 />} />
            <Route path="/insights/openais-gpt55-pro-the-gamechanger-for" element={<Blog28042026 />} />
            <Route path="/insights/can-really-make-your-manufacturing-more" element={<Blog27042026 />} />
            <Route path="/insights/can-agents-predict-your-next-viral" element={<Blog25042026 />} />
            <Route path="/insights/can-ais-country-geniuses-truly-unlock" element={<Blog22042026 />} />
            <Route path="/insights/could-living-neurons-chip-the-ultimate" element={<Blog21042026 />} />
            <Route path="/insights/the-catalyst-your-design-team-needs" element={<Blog20042026 />} />
            <Route path="/insights/can-digital-transformation-propel-your" element={<Blog17042026 />} />
            <Route path="/insights/can-uncover-cyber-threats-that-have" element={<Blog16042026 />} />
            <Route path="/insights/are-you-sabotaging-your-sales-tracking" element={<Blog14042026 />} />
            <Route path="/insights/are-your-cold-email-open-rates" element={<Blog13042026 />} />
            <Route path="/insights/your-ecommerce-business-ready-automate-its" element={<Blog12042026 />} />
            <Route path="/insights/aipowered-vulnerability-discovery-our-digital" element={<Blog11042026 />} />
            <Route path="/insights/anthropics-mythos-too-powerful-for-public" element={<Blog09042026 />} />
            <Route path="/insights/your-mine-operating-peak-potential-discover" element={<Blog07042026 />} />
            <Route path="/insights/your-domain-name-hidden-money-pit" element={<Blog06042026 />} />
            <Route path="/insights/aipowered-coding-the-new-frontier-just" element={<Blog02042026 />} />
            <Route path="/insights/can-weekend-project-truly-deliver-unparalleled" element={<Blog01042026 />} />
            <Route path="/insights/your-mine-unearthing-its-full-potential" element={<Blog28032026 />} />
            <Route path="/insights/can-decentralized-hiring-through-global-coding" element={<Blog26032026 />} />
            <Route path="/insights/your-claude-subscription-25x-more-powerful" element={<Blog25032026 />} />
            <Route path="/insights/blog-23032026" element={<Blog23032026 />} />
            <Route path="/insights/your-strategy-missing-the-forest-for" element={<Blog19032026 />} />
            <Route path="/insights/are-your-skills-aiproof-navigating-the" element={<Blog18032026 />} />
            <Route path="/insights/your-coding-assistant-trapped-your-desk" element={<Blog17032026 />} />
            <Route path="/insights/the-smartest-move-for-your-real" element={<Blog15032026 />} />
            <Route path="/insights/can-you-really-get-claude-capabilities" element={<Blog13032026 />} />
            <Route path="/insights/claude-ais-free-version-redefining-whats" element={<Blog12032026 />} />
            <Route path="/insights/can-transparency-build-more-trust-than" element={<Blog11032026 />} />
            <Route path="/insights/can-elon-musks-5step-engineering-algorithm" element={<Blog10032026 />} />
            <Route path="/insights/can-anthropics-new-claude-cowork-plugins" element={<Blog09032026 />} />
            <Route path="/insights/your-business-ready-understanding-were-confusing" element={<Blog08032026 />} />
            <Route path="/insights/can-pixel-agents-pixelate-your-path" element={<Blog06032026 />} />
            <Route path="/insights/can-seamless-memory-transfer-revolutionize-your" element={<Blog05032026 />} />
            <Route path="/insights/can-rowboat-really-sink-traditional-agencies" element={<Blog04032026 />} />
            <Route path="/insights/agi-2025-really-gamechanger-for-your" element={<Blog01032026 />} />
            <Route path="/insights/your-agency-ready-for-revolution-just" element={<Blog26022026 />} />
            <Route path="/insights/blog-22022026" element={<Blog22022026 />} />
            <Route path="/insights/market-research-the-new-5000-consultant" element={<Blog21022026 />} />
            <Route path="/insights/are-you-ready-let-take-the" element={<Blog20022026 />} />
            <Route path="/insights/can-your-handle-6000-prompts-the" element={<Blog19022026 />} />
            <Route path="/insights/can-bytedances-seedance-transform-filmmaking-just" element={<Blog18022026 />} />
            <Route path="/insights/could-living-brain-cells-the-ultraefficient" element={<Blog17022026 />} />
            <Route path="/insights/can-loss-leader-strategy-really-drive" element={<Blog16022026 />} />
            <Route path="/insights/your-manufacturing-ready-for-industrial-revolution" element={<Blog15022026 />} />
            <Route path="/insights/can-really-outperform-the-500-unpacking" element={<Blog14022026 />} />
            <Route path="/insights/your-existing-content-hidden-goldmine-youre" element={<Blog13022026 />} />
            <Route path="/insights/are-you-missing-out-your-dream" element={<Blog12022026 />} />
            <Route path="/insights/chinas-deepseek-moment-with-manus-ushering" element={<Blog11022026 />} />
      <Route path="/insights/asml-the-secret-engine-powering-every" element={<Blog10022026 />} />
      <Route path="/insights/can-agentic-your-next-best-coworker" element={<Blog09022026 />} />
      <Route path="/insights/can-really-diagnose-illness-better-than" element={<Blog08022026 />} />
      <Route path="/insights/blog-07022026" element={<Blog07022026 />} />
      <Route path="/insights/can-aidriven-wealth-truly-transform-your" element={<Blog06022026 />} />
      <Route path="/insights/could-aiassisted-seo-unlock-your-untapped" element={<Blog05022026 />} />
      <Route path="/insights/are-you-maximizing-your-productivity-how" element={<Blog04022026 />} />
      <Route path="/insights/how-does-your-phone-pinpoint-your" element={<Blog03022026 />} />
      <Route path="/insights/kimi-the-secret-unlocking-unprecedented-business" element={<Blog02022026 />} />
      <Route path="/insights/can-your-browser-become-your-most" element={<Blog01022026 />} />
      <Route path="/insights/blog-31012026" element={<Blog31012026 />} />
      <Route path="/insights/unlock-superpowers-how-manus-redefining" element={<Blog30012026 />} />
      <Route path="/insights/unlock-your-potential-clawdbot-agent-your" element={<Blog29012026 />} />
      <Route path="/insights/unlocking-ais-true-potential-building" element={<Blog28012026 />} />
      <Route path="/insights/unleash-ais-full-power-one-api" element={<Blog27012026Posted />} />
      <Route path="/insights/beyond-the-horizon-how-recursive-language" element={<Reg20012026Posted />} />
      <Route path="/insights/beyond-thumbnails-how-smart-video-previews" element={<SmartVideoPreviews22012026Posted />} />
      <Route path="/insights/unlocking-superpowers-how-bytez-model-api" element={<Blog24012026Posted />} />
      <Route path="/insights/unleash-your-ais-full-potential-how" element={<AgentLightningDrives24012026Posted />} />
      <Route path="/insights/the-future-is-now-unlocking-peak" element={<AIAGENTS23012026Posted />} />
      <Route path="/insights/revolutionize-your-digital-presence-how-ai" element={<AISEO21012026Posted />} />
      <Route path="/insights/ai-seo-marketing-powerhouse" element={<AISEOMarketing />} />
      <Route path="/insights/smart-video-previews-engagement" element={<SmartVideoPreviews />} />
      <Route path="/insights/ai-agents-peak-performance" element={<AIAgents />} />
      <Route path="/insights/agent-lightning-self-correcting-ai" element={<AgentLightning />} />
      <Route path="/insights/recursive-language-models-context-rot-ai-efficiency" element={<RecursiveLanguageModels />} />
      <Route path="/youtube" element={<YouTube />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/p/crosby" element={<CrosbyProposal />} />
    </Routes>
  );
};

// Scroll animation observer
const ScrollAnimationObserver = () => {
  React.useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, observerOptions);

    // Observe all elements with fade-in-up class
    const animatedElements = document.querySelectorAll('.fade-in-up');
    animatedElements.forEach(el => observer.observe(el));

    return () => {
      animatedElements.forEach(el => observer.unobserve(el));
    };
  }, []);

  return null;
};

const AppShell = () => {
  const location = useLocation();
  const isProposal = location.pathname.startsWith('/p/');

  if (isProposal) {
    return <RoutesWithLocation />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-grow">
        <RoutesWithLocation />
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ScrollAnimationObserver />
      <AppShell />
      <AIAssistant />
    </Router>
  );
}

export default App;